import shallow from 'zustand/shallow'
import { useUiStore } from '../../app/hooks'
import useIsMobile from '../../app/hooks/useIsMobile'

/**
 * Provides a boolean if the panel
 * is hovered open and setter function
 * @returns [boolean, function]
 */
export default () => {
  const isMobile = useIsMobile()
  return useUiStore(
    state => [isMobile ? false : state.panelHovered, state.setPanelHovered],
    shallow
  )
}
